import { useQuery } from '@tanstack/react-query';
import ky from 'ky';

import { Vault } from '@/features/vaults/types';
import { pointsDomain } from '@/features/vaults/config';
import { NETWORK_CHAIN } from '@/core/config';
import { CoreVaultDataResponse } from '@/features/vaults/types/coreVaultDataResponse';

export function useCoreVaultData(
  vault: Vault,
  options: { enabled: boolean; staleTime?: number } = { enabled: true },
) {
  return useQuery({
    queryKey: ['vaults', vault.network, 'core-vault-rates', vault.address],
    queryFn: async () => {
      const res = (await ky(
        `${pointsDomain}/v1/chain/${NETWORK_CHAIN[vault.network]}/core-vaults/${
          vault.address
        }/data?extended=true`,
      ).json()) as CoreVaultDataResponse;

      if (!res.lastUpdate) {
        throw new Error('Core vault data not available');
      }

      return res;
    },
    enabled: options.enabled && vault.type === 'core-vault',
    gcTime: Infinity,
    staleTime: options.staleTime || 10 * 60 * 1000,
  });
}
